module.exports = __webpack_public_path__ + "static/img/chomikwr.f936bef2.webp";